import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Phone } from 'lucide-react';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export const PageHeader = () => (
  <header className="header">
    <div className="header-content">
      <Link to="/" className="header-logo-link">
        <img 
          src="https://customer-assets.emergentagent.com/job_nature-health-2/artifacts/zktrrb9e_Logo%20chouquinette.png" 
          alt="Laura Body Naturopathe Angoulême Logo" 
          className="header-logo"
          style={{maxHeight: '60px', width: 'auto'}}
        />
      </Link>
      <nav className="nav-menu">
        <Link to="/" className="nav-link">Accueil</Link>
        <Link to="/services" className="nav-link">Services</Link>
        <Link to="/tarifs" className="nav-link">Tarifs</Link>
        <Link to="/reflexologie-angouleme" className="nav-link">Réflexologie</Link>
        <Link to="/naturopathe-angouleme" className="nav-link">Naturopathie</Link>
        <Link to="/blog" className="nav-link">Blog</Link>
        <a href="/#contact" className="nav-link">Contact</a>
      </nav>
      <div className="header-actions">
        <a href="tel:0650155923" className="header-phone" data-testid="header-phone">
          <Phone size={18} />
          <span className="header-phone-text">06 50 15 59 23</span>
        </a>
        <a href={BOOKING_URL} target="_blank">
          <Button className="btn-reservation">Réserver</Button>
        </a>
      </div>
    </div>
  </header>
);
